import Swiper from 'swiper/bundle';

// var swiper = new Swiper(".header__menu", {
//   breakpoints: {
//     0: {
//       slidesPerView: 'auto',
//       spaceBetween: 8,
//       reverseDirection: true,
//     },
//     769: {
//       slidesPerView: 3,
//       spaceBetween: 8,
//       reverseDirection: false,

//     },
//   },
//   pagination: {
//     el: ".sw-pagination",
//   },
// });

var swiper2 = new Swiper(".mainSlider__slider", {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: ".sw-pagination",
  },
});

var swiper3 = new Swiper(".collections__slider", {
  freeMode: true,
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      spaceBetween: 18,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: ".collections__next",
    prevEl: ".collections__prev",
  },
});

var swiper4 = new Swiper(".catalog__slider", {
  slidesPerView: 'auto',
  freeMode: true,
  spaceBetween: 12,
  navigation: {
    nextEl: ".catalog__next",
    prevEl: ".catalog__prev",
  },
});

var swiper5 = new Swiper(".tems__slider", {
  freeMode: true,
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      spaceBetween: 18,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: ".tems__next",
    prevEl: ".tems__prev",
  },
});

var swiper6 = new Swiper(".trend__slider", {
  freeMode: true,
  slidesPerView: 'auto',
  spaceBetween: 18,
});

var swiper7 = new Swiper(".subcategories__slider", {
  slidesPerView: 'auto',
  spaceBetween: 12,
  freeMode: true,
});


var swiper8 = new Swiper(".product__mobGal", {
  slidesPerView: 1,
  spaceBetween: 18,
  pagination: {
    el: ".sw-pagination",
  },

});

var swiper9 = new Swiper(".similar__slider", {
  freeMode: true,
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      spaceBetween: 18,
    },
    1216: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: ".similar__next",
    prevEl: ".similar__prev",
  },
});
